/**
 * Cloud-security
 * cloud-security RESTful API
 *
 * OpenAPI spec version: default
 * Contact: office@cyan.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { MobileAppBlockingDTO } from '../model/mobileAppBlockingDTO';
import { PutMobileAppBlockingRequest } from '../model/putMobileAppBlockingRequest';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable()
export class MobileAppBlockingService {
  protected basePath = 'https://10.36.200.206:9021/cms-api-gateway/cloudsecurity/api';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

  /**
   * Returns app blocking information for given profile
   *
   * @param profileId profileId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAppsUsingGET(
    profileId: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<MobileAppBlockingDTO>>;
  public getAppsUsingGET(
    profileId: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<MobileAppBlockingDTO>>>;
  public getAppsUsingGET(
    profileId: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<MobileAppBlockingDTO>>>;
  public getAppsUsingGET(
    profileId: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (profileId === null || profileId === undefined) {
      throw new Error(
        'Required parameter profileId was null or undefined when calling getAppsUsingGET.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (JWT) required
    if (this.configuration.apiKeys && this.configuration.apiKeys['Authorization']) {
      headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.get<Array<MobileAppBlockingDTO>>(
      `${this.basePath}/profiles/${encodeURIComponent(String(profileId))}/apps`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Updates app blocking for apps provided in a request body
   * Only provided apps will be updated, returns all app blocking information
   * @param mobileAppBlockings mobileAppBlockings
   * @param profileId profileId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateAppsUsingPUT(
    mobileAppBlockings: Array<PutMobileAppBlockingRequest>,
    profileId: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<MobileAppBlockingDTO>>;
  public updateAppsUsingPUT(
    mobileAppBlockings: Array<PutMobileAppBlockingRequest>,
    profileId: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<MobileAppBlockingDTO>>>;
  public updateAppsUsingPUT(
    mobileAppBlockings: Array<PutMobileAppBlockingRequest>,
    profileId: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<MobileAppBlockingDTO>>>;
  public updateAppsUsingPUT(
    mobileAppBlockings: Array<PutMobileAppBlockingRequest>,
    profileId: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (mobileAppBlockings === null || mobileAppBlockings === undefined) {
      throw new Error(
        'Required parameter mobileAppBlockings was null or undefined when calling updateAppsUsingPUT.'
      );
    }

    if (profileId === null || profileId === undefined) {
      throw new Error(
        'Required parameter profileId was null or undefined when calling updateAppsUsingPUT.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (JWT) required
    if (this.configuration.apiKeys && this.configuration.apiKeys['Authorization']) {
      headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.put<Array<MobileAppBlockingDTO>>(
      `${this.basePath}/profiles/${encodeURIComponent(String(profileId))}/apps`,
      mobileAppBlockings,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }
}
